import React from 'react';
import { Link } from 'gatsby';

const BlogLink = ({ children, isBlogPage, link, key }) => {
  if (isBlogPage) {
    return (
      <Link key={key} to={`/blogs/${link}`}>
        {children}
      </Link>
    );
  }
  return (
    <Link key={key} to={link}>
      {children}
    </Link>
  );
};

export default BlogLink;
